import React from 'react';
import { useIntl } from 'react-intl';
import css from '../LandingPage.css';

// — PL assety
import PL_Bikes from './pl/rower.png';
import PL_Second from './pl/sup.png';
import PL_Promo50 from './pl/secondLife.png';
import PL_Crampons from './pl/raczki.png';

// — CZ assety
import FirstCZ from './cz/cyklo.png';
import SecondCZ from './cz/turda.png';
import ThirdCZ from './cz/fitko.png';

// — HU assety
import FirstHU from './hu/electric.jpg';
import SecondHU from './hu/mtb.jpg';
import ThirdHU from './hu/membership.jpg';

// — SK assety
import FirstSK from './sk/cyklo.png';
import SecondSK from './sk/tent.png';
import ThirdSK from './sk/sup.png';

import { NamedLink } from '../../../components';

const TILES = {
  
  pl: [
    {
      img: FirstCZ,
      titleId: 'PromoTiles.tile4.title',
      linkName: 'SearchPage',
      params: '?keywords=rower'
    },
    // {
    //   img: ThirdCZ,
    //   titleId: 'PromoTiles.tile2.title',
    //   linkName: 'FitnessCardioSearchPage'
    // },
    {
      img: PL_Crampons,
      titleId: 'PromoTiles.tile1.title',
      linkName: 'TourismCramponsSearchPage'
    },
    {
      img: PL_Promo50,
      titleId: 'PromoTiles.tile3.title',
      externalLink:
        'https://www.decathlon.pl/produkty-second-life/rowery-second-life',
    },
  ],
  cz: [
    {
      img: FirstCZ,
      titleId: 'PromoTiles.tile1.title',
      linkName: 'SearchPage',
      params: '?keywords=kolo'
    },
    {
      img: SecondCZ,
      titleId: 'PromoTiles.tile2.title',
      linkName: 'CampingTentSearchPage',
    },
    {
      img: ThirdCZ,
      titleId: 'PromoTiles.tile3.title',
      linkName: 'FitnessCardioSearchPage',
    },
  ],
  sk: [
    {
      img: FirstSK,
      titleId: 'PromoTiles.tile1.title',
      linkName: 'SearchPage',
      params: '?keywords=bicykel'
    },
    {
      img: SecondSK,
      titleId: 'PromoTiles.tile2.title',
      linkName: 'CampingRoofTentSearchPage',
    },
    {
      img: ThirdSK,
      titleId: 'PromoTiles.tile3.title',
      linkName: 'WatersportsSupSearchPage',
    },
  ],
  hu: [
    {
      img: FirstHU,
      titleId: 'PromoTiles.tile1.title',
      linkName: 'ElectricBikesSearchPage'
    },
    {
      img: SecondHU,
      titleId: 'PromoTiles.tile2.title',
      linkName: 'MountainBikesSearchPage',
    },
    {
      img: ThirdHU,
      titleId: 'PromoTiles.tile3.title',
      externalLink: 'https://membership.decathlon.com/hu-HU'
    },
  ],
};

export function getTilesConfig() {
  const country = process.env.REACT_APP_COUNTRY_ID;
  return TILES[country] || TILES.pl;
}

const PromoTiles = () => {
  const intl = useIntl();
  const tiles = getTilesConfig();

  return (
    <div className={css.promoTilesSectionWrapper}>
      <div className={css.promoTilesWrapper}>
        {tiles.map((tile, idx) => {
          const title = intl.formatMessage({ id: tile.titleId });

          const TileContent = (
            <>
              <div className={css.promoTileImgWrapper}>
                <img src={tile.img} alt={title} className={css.promoTileImg} />
              </div>
              <div className={css.promoTileBottom}>
                <div className={css.promoTileText}>{title}</div>
                <div className={css.promoTileBtn}>
                  {intl.formatMessage({ id: 'PromoTiles.btn' })}
                </div>
              </div>
            </>
          );

          if (tile.linkName) {
            return (
              <NamedLink
                id="mainPageTileLink"
                className={css.promoTile}
                name={tile.linkName}
                key={idx}
                to={tile.params ? { search: tile.params } : {}}
              >
                {TileContent}
              </NamedLink>
            );
          }

          if (tile.externalLink) {
            return (
              <a
                id="mainPageTileLink"
                className={css.promoTile}
                href={tile.externalLink}
                target="_blank"
                rel="noopener noreferrer"
                key={idx}
              >
                {TileContent}
              </a>
            );
          }

          return (
            <div className={css.promoTile} key={idx}>
              {TileContent}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PromoTiles;